<template>
  <v-dialog v-model="internalShowDialog" persistent max-width="350">
    <v-card align="center">
      <v-card-title class="headline justify-center">
        <p :class="title === 'Success' ? 'text-success' : 'text-error'">
          {{ title }}
        </p>
      </v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="close" dark color="purple darken-1" @click="confirm"
          >ยืนยัน</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    show: Boolean,
    close: Boolean,
  },
  computed: {
    internalShowDialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm", false);
    },
  },
};
</script>
<style scoped>
.text-error {
  color: red;
}
.text-success {
  color: green;
}
</style>
